import {
  currentLocale,
  currentNumberFormat,
  currentTimeZone
} from '../../functions/global-date-functions'
import {
  formatCurrencyStandalone,
  formatDateRangeStandalone,
  formatDateStandalone,
  formatDateTimeStandalone,
  formatNumberStandalone,
  formatPercentStandalone,
  formatPhoneNumberStandalone,
  formatPluralStandalone,
  formatTimeStandalone,
  type DateTimeStyle,
  type FormatCurrencyOptions,
  type FormatDateTimeOptions,
  type FormatNumberOptions,
  type FormatPercentOptions,
  type PluralForms
} from '../../functions/format-standalone'

export function useFormatting() {
  return {
    formatDate(
      value: string | null | undefined,
      style?: DateTimeStyle,
      options?: FormatDateTimeOptions
    ): string {
      return formatDateStandalone(
        value,
        currentLocale.value,
        currentTimeZone.value,
        style,
        options
      )
    },

    formatDateRange(
      from: string | null | undefined,
      to: string | null | undefined,
      style?: DateTimeStyle,
      options?: FormatDateTimeOptions
    ): string {
      return formatDateRangeStandalone(
        from,
        to,
        currentLocale.value,
        currentTimeZone.value,
        style,
        options
      )
    },

    formatDateTime(
      value: string | null | undefined,
      style?: DateTimeStyle,
      options?: FormatDateTimeOptions
    ): string {
      return formatDateTimeStandalone(
        value,
        currentLocale.value,
        currentTimeZone.value,
        style,
        options
      )
    },

    formatTime(
      value: string | null | undefined,
      style?: DateTimeStyle
    ): string {
      return formatTimeStandalone(
        value,
        currentLocale.value,
        currentTimeZone.value,
        style
      )
    },

    formatNumber(
      value: number | null | undefined,
      options?: FormatNumberOptions
    ): string {
      return formatNumberStandalone(value, currentNumberFormat.value, options)
    },

    formatCurrency(
      value: number | null | undefined,
      currencyCode: string,
      options?: FormatCurrencyOptions
    ): string {
      return formatCurrencyStandalone(
        value,
        currencyCode,
        currentNumberFormat.value,
        options
      )
    },

    formatPercent(
      value: number | null | undefined,
      options?: FormatPercentOptions
    ): string {
      return formatPercentStandalone(value, currentNumberFormat.value, options)
    },

    formatPhoneNumber(value: string | null | undefined): string {
      return formatPhoneNumberStandalone(value)
    },

    formatPlural(count: number, forms: PluralForms): string {
      return formatPluralStandalone(count, forms, currentLocale.value)
    }
  }
}
